import React, {useEffect, useMemo, useState} from "react";
import ApiConnect from "../../../Util/ApiConnect";
import CompanyHeader from "./CompanyHeader";
import {Redirect, useParams} from "react-router-dom";
import ProductCard from "./ProductCard";
import Skeleton from "../Skeleton";
import CategorySlider from "./CategorySlider";

const CompanyMenu = () => {
    const {company, id} = useParams();
    const [companyData, setCompanyData] = useState(null);
    const [productData, setProductData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCatId, setActiveCatId] = useState("ALL");

    useEffect(() => {
        ApiConnect.get(
            `/CustomerQR/CompanyMenu?company=${company}&id=${id}`
        )
            .then((response) => {
                if (response.status === 200) {
                    setCompanyData(response.data.company);
                    setProductData(response.data.product);
                    setCategoryData(response.data.category);
                    setLoading(false);
                } else {
                    <Redirect to="/404"/>;
                }
            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    }, [company, id])


    const visibleProducts = useMemo(() => {
        if (activeCatId === "ALL") return productData;
        return productData.filter((p) => p.category_id === activeCatId);
    }, [activeCatId, productData]);


    if (loading) {
        return <Skeleton/>
    }

    return (
        <>  <CompanyHeader data={companyData}/>
            <div className="bg-white border-bottom overflow-hidden" style={{top: 0}}>

                <div className="container position-relative">
                    <div className=" pt-3">

                        <div className="bg-white border-bottom sticky-top px-3 pt-2 pb-3">
                       <CategorySlider
                           categoryData={categoryData}
                           activeCatId={activeCatId}
                           setActiveCatId={setActiveCatId}
                       />
                        </div>
                    </div>
                    <div className="shadow-sm rounded bg-white mb-3">

                        <div className="col-md-12 p-4 ">
                            <div className="row g-2 g-md-3">
                                {visibleProducts.length ? (
                                    visibleProducts.map((p) =>
                                        <div className={"col-6 col-md-4"} key={p.id}>
                                            <ProductCard key={p.id} {...p}  />
                                        </div> )
                                ) : (
                                    <p className="text-center text-muted py-5">No items found.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default CompanyMenu;
